module.exports = __webpack_public_path__ + "951e3794f22d8fe360605b039ee14d4b.svg";